import { render } from "./ProductPreloader.vue?vue&type=template&id=70421df8"
import script from "./ProductPreloader.vue?vue&type=script&lang=js"
export * from "./ProductPreloader.vue?vue&type=script&lang=js"

import "./ProductPreloader.vue?vue&type=style&index=0&id=70421df8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__